const state = {
    webSocketMsg: "",
    systemKey: "NB", // NB-宁波、QD-青岛、SH-上海、大连-DL
    screenWidth: document.body.clientWidth,
    isLookAds: false, // 是否看过广告了
    recentSubscribeList: [], // 最近订阅列表
    abroadMapCollapsed: false, // 海外运踪地图折叠状态
    abroadLayoutMode: "old", // 国外节点布局模式
};

const mutations = {
    SET_WS_MSG: (state, msg) => {
        state.webSocketMsg = msg;
    }, //聊天室消息记录
    editSystemKey(state, payload) {
        state.systemKey = payload;
    },
    updateScreenWidth(state, payload) {
        state.screenWidth = payload;
    },
    setLookAds(state, payload) {
        state.isLookAds = payload;
    },
    setRecentSubscribeList(state, payload) {
        state.recentSubscribeList = payload;
    },
    setAbroadMapCollapsed(state, payload) {
        state.abroadMapCollapsed = payload;
    },
    setAbroadLayoutMode(state, payload) {
        state.abroadLayoutMode = payload;
    },
};

const actions = {};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
